import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AlertDashboardNotice } from '../types/dashboard';

interface AlertSetupNoticesProps {
  notices: AlertDashboardNotice[];
}

/** Prominent dashboard banner when alerts need webhook / trigger setup. */
const AlertSetupNotices: React.FC<AlertSetupNoticesProps> = ({ notices }) => {
  const navigate = useNavigate();

  if (!notices.length) {
    return null;
  }

  return (
    <Box sx={{ mb: 3 }}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography variant="subtitle2" fontWeight={600} gutterBottom>
          {notices.length === 1
            ? '1 alert needs setup before webhooks can run'
            : `${notices.length} alerts need setup before webhooks can run`}
        </Typography>
        <Typography variant="body2">
          Fix each item below in Alerts (edit the alert → Incoming webhook / webhook URL).
        </Typography>
        <Button
          size="small"
          variant="outlined"
          sx={{ mt: 1 }}
          onClick={() => navigate('/alerts')}
        >
          Open Alerts
        </Button>
      </Alert>
      <Stack spacing={1.5}>
        {notices.map((notice) => (
          <Alert
            key={`${notice.alertId}-${notice.message.slice(0, 32)}`}
            severity={notice.severity}
            variant="outlined"
            action={
              <Button
                color="inherit"
                size="small"
                onClick={() => navigate('/alerts')}
              >
                Fix
              </Button>
            }
          >
            <Typography variant="subtitle2" fontWeight={600}>
              {notice.stockSymbol} · {notice.positionType}
            </Typography>
            <Typography variant="body2">{notice.message}</Typography>
          </Alert>
        ))}
      </Stack>
    </Box>
  );
};

export default AlertSetupNotices;
